/**
 * HTML 엔티티(&nbsp;, &#160;)를 공백으로 변환
 * @param text 변환할 텍스트
 * @returns 변환된 텍스트
 */
export const convertHtmlEntitiesToSpaces = (text: string): string => {
  return text.replace(/&nbsp;|&#160;/g, ' ');
};
